import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { AbstractPageBuilderService } from '../../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { BriefingChartDisplayElementModel } from '../../../../../Common/PageBuilder/models/briefing-chart-display-element.model';
import { ChartDisplayElementModel } from '@Common/Reports/models/chart-display-element.model';

@Component({
    selector: 'agpr-briefing-chart-dimensions-field',
    templateUrl: './briefing-chart-dimensions-field.component.html',
    styleUrls: ['./briefing-chart-dimensions-field.component.scss'],
    standalone: false
})
export class BriefingChartDimensionsFieldComponent extends AbstractFormFieldComponent implements OnInit {

    widthPercent: number;
    hasData: boolean;

    constructor(
        public pageBuilderService: AbstractPageBuilderService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit(): void {
        this.widthPercent = this.value.widthPercent;
        const chartDisplayElement = (this.block.displayElement as BriefingChartDisplayElementModel)?.chartBlock?.displayElement as ChartDisplayElementModel;
        if (chartDisplayElement) {
            const seriesData = chartDisplayElement.series[0].dataProvider.getValue();
            this.hasData = !!seriesData;
        }
    }

    chartWidthChanged(widthPercent: number): void {
        this.value.widthPercent = widthPercent;
        this.changeDetectorRef.detectChanges();
        this.changes.emit(this.value);
        if (!this.hasData) {
            this.pageBuilderService.refreshBlockData(this.block);
            this.hasData = true;
        }
    }

    chartHeightChanged(height: number): void {
        this.value.heightPx = height;
        this.changeDetectorRef.detectChanges();
        this.changes.emit(this.value);
    }

    chartHeightEmitted(): void {
        this.changeDetectorRef.detectChanges();
        this.changes.emit(this.value);
        if (!this.hasData) {
            this.pageBuilderService.refreshBlockData(this.block);
            this.hasData = true;
        }
    }
}
